
import React, { Component } from 'react';
import {
  daysInMonth, weekDayInMonth, getDateForCalendar, getMonth,
} from '../utils/common';
import SVGComponent from './SVG/SVGComponent';
import { SVG_ICONS, TOTAL_DATES_TO_SHOW } from '../constants';

export default class NewCalendar extends Component {
  constructor(props) {
    super(props);

    const defaultDate = props.filter[props.field];
    const selectedDate = defaultDate ? new Date(defaultDate) : new Date();

    this.state = {
      month: new Date(selectedDate.getTime()),
      selectedDate,
      date: defaultDate ? new Date(defaultDate) : null,
    };

    this.inactiveDatesBefore = [];
    this.activeDates = [];
    this.inactiveDatesAfter = [];

    // COMPONENT WILL MOUNT
    this.setDataForOneMonth(this.state.selectedDate);
  }

  /**
   * Update state on clear filter
   *
   * @param {object} prevProps
   * @returns {void}
   */
  componentDidUpdate(prevProps) {
    if (this.props.filter[this.props.field] !== prevProps.filter[prevProps.field]) {
      const defaultDate = this.props.filter[this.props.field];
      const selectedDate = defaultDate ? new Date(defaultDate) : new Date();

      this.setState({
        month: new Date(selectedDate.getTime()),
        selectedDate,
        date: defaultDate ? new Date(defaultDate) : null,
      });
    }
  }

  /**
   * Set previous month
   *
   * @function
   * @returns {void}
   */
  setPreviousMonth = () => {
    const month = this.state.month;
    if (this.props.inactivePreviousDates
      && this.props.inactivePreviousDates.getMonth() === month.getMonth()) {
      return;
    }
    month.setMonth(month.getMonth() - 1, 1);
    this.setDataForOneMonth(month);
    this.setState({
      month,
    });
  };

  /**
   * Set next month
   *
   * @function
   * @returns {void}
   */
  setNextMonth = () => {
    const month = this.state.month;
    month.setMonth(month.getMonth() + 1, 1);
    this.setDataForOneMonth(month);
    this.setState({
      month,
    });
  };

  /**
   * Change day
   *
   * @function
   * @param {number} day
   * @returns {void}
   */
  setDay = (day) => {
    const date = this.state.selectedDate;
    date.setFullYear(this.state.month.getFullYear(), this.state.month.getMonth(), day);

    this.setState({
      selectedDate: date,
      month: new Date(date.getTime()),
    });
  };

  /**
   *
   * @function
   * @returns {void}
   */
  applyDate = () => {
    this.props.handleDateChange(this.state.selectedDate);

    this.props.closeCalendar();
  };

  /**
   * Calculate month view
   *
   * @function
   * @param {Time} date
   */
  setDataForOneMonth = (date) => {
    const copiedDate = new Date(date.getTime());

    let numOfDays = daysInMonth(copiedDate.getMonth() + 1, copiedDate.getFullYear());
    const startWith = weekDayInMonth(copiedDate.getMonth(), copiedDate.getFullYear());
    copiedDate.setFullYear(copiedDate.getFullYear(), copiedDate.getMonth() - 1, 1);
    let numOfDaysPreviousMonth = daysInMonth(copiedDate.getMonth() + 1, copiedDate.getFullYear());
    numOfDaysPreviousMonth -= startWith;
    this.inactiveDatesBefore = Array(startWith).fill().map(() => {
      numOfDaysPreviousMonth += 1;
      return numOfDaysPreviousMonth;
    });
    let counter = 0;
    if (this.props.inactivePreviousDates
      && this.props.inactivePreviousDates.getMonth() === this.state.month.getMonth()) {
      const numOfInvalidDates = this.props.inactivePreviousDates.getDate() - 1;
      Array(numOfInvalidDates).fill().map(() => {
        counter += 1;
        this.inactiveDatesBefore.push(counter);
      });
      numOfDays -= numOfInvalidDates;
    }
    this.activeDates = Array(numOfDays).fill().map(() => {
      counter += 1;
      return counter;
    });
    let i = 0;
    this.inactiveDatesAfter = Array(TOTAL_DATES_TO_SHOW - counter - startWith).fill().map(() => {
      i += 1;
      return i;
    });
  };

  /**
   * Parse date objects
   *
   * @function
   * @returns {object}
   */
  getCalendarData = () => {
    const fullDate = getDateForCalendar(this.state.selectedDate);
    let date = getDateForCalendar(this.state.date);
    date = date.slice(0, -4) + date.slice(date.length - 2, date.length);

    const month = getMonth(this.state.month);
    const currentDay = this.state.month.getMonth() === this.state.selectedDate.getMonth()
      ? this.state.selectedDate.getDate() : -1;
    return {
      currentDay, date, month, fullDate,
    };
  };

  /**
   * Render
   *
   * @returns {view}
   */
  render() {
    const data = this.getCalendarData();

    return (
      <div className="calendar__popup-sub">

        <div className="calendar">
          <div className="calendar__head">
            <span>Select Date</span>
            {' '}
            <SVGComponent
              className="calendar__close-btn"
              src={`${SVG_ICONS.utility}#close`}
              onClick={this.props.closeCalendar}
            />
          </div>
          <hr className="spacer-line m-t-10 m-b-10" />
          <div className="calendar__display">
            <span className="calendar__display-prev" onClick={this.setPreviousMonth} />
            {' '}
            <span className="calendar__display-date">{data.month}</span>
            {' '}
            <span className="calendar__display-next" onClick={this.setNextMonth} />
          </div>

          <div className="calendar__table m-t-10">
            <div className="calendar__cell calendar__cell--day"><span>Su</span></div>
            <div className="calendar__cell calendar__cell--day"><span>Mo</span></div>
            <div className="calendar__cell calendar__cell--day"><span>Tu</span></div>
            <div className="calendar__cell calendar__cell--day"><span>We</span></div>
            <div className="calendar__cell calendar__cell--day"><span>Th</span></div>
            <div className="calendar__cell calendar__cell--day"><span>Fr</span></div>
            <div className="calendar__cell calendar__cell--day"><span>Sa</span></div>

            {
              this.inactiveDatesBefore.map((day) => (
                <div className="calendar__cell calendar__cell--disabled" key={day}><span>{day}</span></div>
              ))
            }

            {
              this.activeDates.map((day) => (
                <div
                  key={day}
                  className={`calendar__cell ${data.currentDay === day ? 'active' : ''}`}
                  onClick={this.setDay.bind(this, day)}
                >
                  <span>{day}</span>
                </div>
              ))
            }

            {
              this.inactiveDatesAfter.map((day) => (
                <div className="calendar__cell calendar__cell--disabled" key={day}><span>{day}</span></div>
              ))
            }

          </div>

          <hr className="spacer-line grey m-t-10 m-b-10" />
          <div className="calendar__btn-wrap">
            <button
              type="button"
              className="btn btn-secondary"
              onClick={this.props.closeCalendar}
            >
              Cancel
            </button>
            {' '}
            <button
              type="button"
              className="btn btn-primary m-l-10"
              onClick={this.applyDate}
            >
              Apply
            </button>
          </div>
        </div>

      </div>

    );
  }
}
